import React, { FC, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover.tsx";

interface ColorPickerProps {
	color: string;
	onChange: (color: string) => void;
}

const DEFAULT_COLORS = [
	"#FF6900",
	"#FCB900",
	"#7BDCB5",
	"#00D084",
	"#8ED1FC",
	"#0693E3",
	"#ABB8C3",
	"#EB144C",
	"#F78DA7",
	"#9900EF",
];

export const ColorPicker: FC<ColorPickerProps> = (props) => {
	const [open, setOpen] = useState(false);
	const handleClick = (color: string) => () => {
		props.onChange(color);
		setOpen(!open);
	};

	return (
		<>
			<Popover open={open} onOpenChange={setOpen}>
				<PopoverTrigger asChild>
					<span
						className={
							"inline-block w-8 h-8 rounded border border-input shadow-sm dark:shadow-dark-sm"
						}
						style={
							props.color
								? { backgroundColor: props.color }
								: {
										backgroundImage:
											"border border-red-500",
									}
						}
					/>
				</PopoverTrigger>
				<PopoverContent asChild>
					<div className={"grid grid-cols-6 gap-1"}>
						<div
							onClick={handleClick("")}
							title="None"
							className={
								"w-8 h-8 rounded cursor-pointer mb-2 border border-secondary"
							}
						/>
						{DEFAULT_COLORS.map((color) => (
							<div
								key={color}
								onClick={handleClick(color)}
								className={
									"w-8 h-8 rounded cursor-pointer mb-2 border border-secondary"
								}
								style={{ backgroundColor: color }}
							/>
						))}
						<div
							className="custom-color-input border border-secondary"
							style={{ backgroundColor: props.color }}
						>
							<input
								type={"color"}
								value={props.color || "#000000"}
								onChange={(e) =>
									props.onChange(
										e.target.value,
									)
								}
							/>
							<span
								className={
									"absolute text-xl pointer-events-none"
								}
								style={{ top: 1, left: 9 }}
							>
								#
							</span>
						</div>
					</div>
				</PopoverContent>
			</Popover>
		</>
	);
};
